import Image from "next/image";
import logo from "../../../../../public/images/graboxy/logo.svg";
const styles = new Proxy({"Logo":"Logo-fce4a"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const Logo = () => {
  return (
    <Image
      src={logo.src}
      alt="Graboxy Logo"
      className={styles.Logo}
      width={155}
      height={36}
    />
  );
};

export const ColLogo = () => (
  <div className="container">
    <div className="row text-center">
      <div className="col-12 py-5">
        <Logo />
      </div>
    </div>
  </div>
);

export default Logo;
